var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPresentation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8571 9.85714H14.5714C14.3348 9.85714 14.1429 9.66525 14.1429 9.42857V2.14286C14.1429 0.959473 13.1834 0 12 0C10.8166 0 9.85714 0.959473 9.85714 2.14286V9.42857C9.85714 9.66525 9.66525 9.85714 9.42857 9.85714H2.14286C0.959473 9.85714 0 10.8166 0 12C0 13.1834 0.959473 14.1429 2.14286 14.1429H9.42857C9.66525 14.1429 9.85714 14.3348 9.85714 14.5714V21.8571C9.85714 23.0405 10.8166 24 12 24C13.1834 24 14.1429 23.0405 14.1429 21.8571V14.5714C14.1429 14.3348 14.3348 14.1429 14.5714 14.1429H21.8571C23.0405 14.1429 24 13.1834 24 12C24 10.8166 23.0405 9.85714 21.8571 9.85714Z",
    fill: "#4982F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPresentation);
export default __webpack_public_path__ + "static/media/addPresentation.a9aaf9596aa91f0b20b64b74464415e6.svg";
export { ForwardRef as ReactComponent };